import React, {
  createContext, useContext,
} from 'react';
import { FlowBuilderContext } from 'pages/Flow/FlowBuilder/FlowBuilderContextProvider';
import { convertToReactFlowRemoveChange } from 'pages/Flow/FlowRender';
import { deleteFlowNode, updateFlowNodesAction } from 'redux/actions/FlowAction';
import { useDispatch, useSelector } from 'react-redux';


export const DeleteNodeContext = createContext({});

export const DeleteNodeContextProvider = ({ children }) => {
  const {
    crId,
    flowId: flowID,
    handleFlowChangeConfirmation,
  } = useContext(FlowBuilderContext);
  const dispatch = useDispatch();
  const orgId = useSelector(state => state.session.user?.primaryOrganization.organization.ID ?? '');

  const handleOnConfirm = async ({ nodeId }) => {
    await dispatch(deleteFlowNode({
      crId,
      orgId,
      flowID,
      nodeId,
    }));
  };

  const handleConfirmAction = ({ nodeId }) => {
    // Prompt user confirmation to delete
    handleFlowChangeConfirmation({
      type: 'NODE_DELETE',
      handle: (action) => {
        if (action.type === 'continue') {
          handleOnConfirm({ nodeId });
        }

        // Update local redux state for react flows
        const changes = convertToReactFlowRemoveChange([{ id: nodeId }]);
        dispatch(updateFlowNodesAction(changes));
      },
    });
  };

  const flowBuilderContextValue = {
    confirmAction: handleConfirmAction,
  };

  return (
    <DeleteNodeContext.Provider value={flowBuilderContextValue}>
      {children}
    </DeleteNodeContext.Provider>
  );
};
